import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { costs } from '../data/problems';
export function ProblemSection() {
  return <section className="border-t border-gray-200 bg-white py-16 sm:py-20" aria-labelledby="problem-title" data-id="element-155" data-mp="30hzhn1ayjuld">
      <div className="mx-auto max-w-4xl px-4" data-id="element-156" data-mp="2vowo2t66kl56">
        <div className="text-center" data-id="element-157" data-mp="39hmagypmfs2t">
          <SectionHeading id="problem-title" data-id="element-158" data-mp="39gkvij5hilft">Does This Sound <span className="text-aqua" data-id="element-159" data-mp="35gar3axcc332">Familiar?</span></SectionHeading>
          <p className="mx-auto mt-6 max-w-3xl text-lg leading-relaxed text-gray-600" data-id="element-160" data-mp="35g0x7c96dbs3">
            You work on the production floor, in QA or QC, in validation, engineering or maintenance of a pharmaceutical
            plant, or you want to enter the industry, but how the whole operation fits together under GMP is never
            explained clearly. When someone talks about deviations, CAPA, cleanroom grades, pressure cascades, aseptic
            filling or validation, you can&apos;t connect all the pieces with confidence.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-10 rounded-xl border border-gray-200 bg-pearl p-6 sm:p-8" data-id="element-161" data-mp="obeuapuxm65f">
          <p className="mb-5 inline-flex items-center gap-2 text-xl font-bold text-navy" data-id="element-162" data-mp="12336et56kume">
            <AlertTriangleIcon className="h-5 w-5 text-gold-dark" aria-hidden="true" data-id="element-163" data-mp="171efh1nnj13k" />
            The real cost:
          </p>
          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-164" data-mp="1bzoc7gp0y9ra">
            {costs.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-gray-600" data-id="element-165" data-mp="1g22thwd1p1gg">
                <span className="mt-1.5 h-2 w-2 shrink-0 rounded-full bg-aqua" aria-hidden="true" data-id="element-166" data-mp="3dugy5e4880re" />
                {item}
              </li>)}
          </ul>
        </motion.div>

        <div className="mt-10 text-center" data-id="element-167" data-mp="ozqysdpitzyp">
          <p className="mx-auto max-w-2xl text-lg font-semibold text-navy" data-id="element-168" data-mp="p0iqvejwtfk8">
            You don&apos;t need more scattered information.
          </p>
          <p className="mt-3 text-2xl font-bold tracking-tight text-aqua sm:text-3xl" data-id="element-169" data-mp="y1gnhbs0qkss">You need one organized system.</p>
        </div>
      </div>
    </section>;
}